// Componente simple de botón de opciones con tres puntos para RecipeCard
import React from 'react';
import { Dropdown, DropdownItem, DropdownDivider } from '../../../shared/components/ui';
import { useTranslation } from 'react-i18next';

const RecipeOptionsButton = ({
    recipe,
    onToggleFavorite,
    onEditRecipe,
    onViewDetails,
    onArchive
}) => {
    const { t } = useTranslation();
    
    return (
        <Dropdown
            trigger={
                <button
                    className="p-2 bg-white/90 backdrop-blur-sm rounded-full shadow-md hover:bg-white transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary-500"
                    aria-label={t('common.options') || 'Opciones'}
                >
                    <span className="text-gray-700 text-xl font-bold leading-none">⋯</span>
                </button>
            }
            align="right"
        >
            {/* Favorito */}
            {onToggleFavorite && (
                <DropdownItem
                    icon={recipe.is_favorite ? '❤️' : '🤍'}
                    onClick={() => onToggleFavorite(recipe.id)}
                    variant={recipe.is_favorite ? 'primary' : 'default'}
                >
                    {recipe.is_favorite ? t('recipe.card.unfavorite') || 'Quitar de favoritas' : t('recipe.card.favorite') || 'Marcar como favorita'}
                </DropdownItem>
            )}

            <DropdownDivider />

            {/* Editar */}
            {onEditRecipe && (
                <DropdownItem
                    icon="✏️"
                    onClick={() => onEditRecipe(recipe)}
                    variant="success"
                >
                    {t('common.edit')} {t('navigation.recipes')?.toLowerCase() || 'receta'}
                </DropdownItem>
            )}

            {/* Ver detalles */}
            {onViewDetails && (
                <DropdownItem
                    icon="👁️"
                    onClick={() => onViewDetails(recipe.id)}
                    variant="primary"
                >
                    {t('menu.display.viewDetails')}
                </DropdownItem>
            )}

            <DropdownDivider />

            {/* Archivar */}
            {onArchive && (
                <DropdownItem
                    icon={recipe.is_archived ? '📤' : '📦'}
                    onClick={() => onArchive(recipe.id)}
                    variant="default"
                >
                    {recipe.is_archived ? t('menu.display.unarchive') || 'Desarchivar' : t('menu.display.archive')}
                </DropdownItem>
            )}
        </Dropdown>
    );
};

export default RecipeOptionsButton;

